import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-t-distances',
  templateUrl: './t-distances.component.html',
  styleUrls: ['./t-distances.component.css']
})
export class TDistancesComponent extends GeneralTeacherComponent {

  words: string[];
  wordsS: string;
  givenPairs: boolean;

  possibleWords: string[][] = [];

  constructor(topicService: TopicService, activatedRoute: ActivatedRoute, protected http: HttpClient) {
    super(topicService, activatedRoute)
    this.type = "distances";
    this.title = this.get("distances");
    this.loadText();

   }

   setInformationWithConfiguration(){
     super.setInformationWithConfiguration();
     this.words = this.configuration.typespecifics.words;
     this.wordsS = this.words.toString();
     console.log(this.configuration.typespecifics.modus);
     this.givenPairs = (this.configuration.typespecifics.modus == "given");
   }

    /** loads the text to generate words from */
  loadText(): Promise<any> {
    let textFile = "./assets/text_" + this.topicService.getLanguage() + ".txt";
    let self = this;
    return new Promise((resolve, reject) => {
      this.http
        .get<any>(textFile)
        .subscribe(response => {
          self.possibleWords = response.wordDistance;
          console.log(self.possibleWords)
          resolve(true);
        })
    })
  }

   generateDefinition(){
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/distances.png";
    definition.level = 1;
    definition.key = "selfcorrecting%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.words = this.words;
    definition.typespecifics.modus = this.givenPairs? "given": "build";
    definition.key = definition.key.concat("%", this.words.toString(), "%", definition.typespecifics.modus.toString());

    return definition;
   }

   reset(){
     super.reset();
     this.words = [];
     this.wordsS = "";
     this.givenPairs = false;
     this.title = this.get("distances");
   }

   /** sets the word array */
   onChangeWords(){
     this.words = this.wordsS.split(/[, \n]+/).map(v => v.toUpperCase());
     this.wordsS = this.words.join(", ");
   }

   generate(){
    this.title = this.get("distances");
    this.givenPairs = Math.random() > 0.5;
    this.generateText();
  }


  /** generates some words */
   generateText(){
    let index = Math.floor(Math.random() * this.possibleWords.length);
    this.words = this.possibleWords[index];
    this.wordsS = this.words.join(", ");
   }

}
